import { render, staticRenderFns } from "./ChainStats.vue?vue&type=template&id=800ea9d0&scoped=true&"
import script from "./ChainStats.vue?vue&type=script&lang=js&"
export * from "./ChainStats.vue?vue&type=script&lang=js&"
import style0 from "./ChainStats.vue?vue&type=style&index=0&id=800ea9d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800ea9d0",
  null
  
)

export default component.exports